// extracted by mini-css-extract-plugin
export default {"users":"Users_users__KZHPM","toggle":"Users_toggle__kWiyP","list":"Users_list__VFtaW"};